import { subscribe } from '@/utils/event-bus'
import {
  addSaveItemGA4,
  addSaveItemKlaviyo,
  addSaveItemStatsig,
  removeSaveItemGA4,
  removeSaveItemKlaviyo,
  removeSaveItemStatsig,
  printPageGA4,
  printPageKlaviyo,
  printPageStatsig,
} from '@/utils/tracking/services'

subscribe('add_save_item', [addSaveItemGA4, addSaveItemKlaviyo, addSaveItemStatsig])
subscribe('remove_save_item', [removeSaveItemGA4, removeSaveItemKlaviyo, removeSaveItemStatsig])
subscribe('print_page', [printPageGA4, printPageKlaviyo, printPageStatsig])
